import React from 'react';

import { get } from 'lodash';
import { useShowContextRequired } from 'ui-builder';
import { Name } from 'nekst-api';

export interface Props {
  source: string
}

export default function FullNameField(props: Props) {
  const { data } = useShowContextRequired();

  const name = get(data, props.source) as Name;

  const fullName = `${name.firstName} ${name.lastName}`;

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {fullName}
    </>
  );
}
